document.addEventListener("DOMContentLoaded", () => {
  setupAverageRateModalListener();
  showAverageRateOnMonthSelection();
  $("#currency-rates-month").select2();
  filterCurrencyToDropdown();
  render_dollar_rates_table();
});

const showCurrentMonthMessage = () => {
  let currentDate = new Date();
  let lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  let formatted_current_date =
    currentDate.toDateString().slice(4, 7) +
    currentDate.toDateString().slice(10, 15);
  if (
    $("#currency_rate_month_drop").val().toString() == formatted_current_date &&
    currentDate.toDateString() != lastDayOfMonth.toDateString()
  ) {
    $("#success-message").show();
    append_success_message(
      [
        `This rate is partially calculated based on the days till date for this month `,
      ],
      "",
      $("#success-message")
    );
  } else {
    $("#success-message").hide();
  }
};

const showAverageRateOnMonthSelection = () => {
  $("#dollar_rate").select2();
  $("#currency_rate_month_drop")
    .datetimepicker({
      format: window.MONTH_YEAR_FORMAT,
      viewMode: "months",
      date: moment($("#currency_rate_month_drop").data("default")),
      maxDate: moment($("#currency_rate_month_drop").data("max-month")),
      minDate: moment($("#currency_rate_month_drop").data("min-month")),
    })
    .on("dp.change", (e) => {
      if ($(e.target).val()) {
        $.ajax({
          type: "get",
          dataType: "json",
          url: "/currency_rates",
          data: {
            currency_rate_month: $(e.target).val(),
            show_average_rate: true,
          },
          success(response) {
            if (response.average_rate != null) {
              $(".average_currency_rate").html(
                `Average Rate: ${response.average_rate}`
              );
              showCurrentMonthMessage();
            } else {
              $(".average_currency_rate").html(`${response.warning_message}`);
            }
          },
        });
      }
    });
};

const setupAverageRateModalListener = () => {
  $("#set-average-rate").on("show.bs.modal", function () {
    const fromValue = document.getElementById("currency-from").value;
    const toValue = document.getElementById("currency-to").value;
    const monthYearSelect = document.getElementById("currency-rates-month");
    const monthYearText =
      monthYearSelect.options[monthYearSelect.selectedIndex].text;

    document.getElementById("modal-currency-from").value = fromValue;
    document.getElementById("modal-currency-to").value = toValue;
    document.getElementById("modal-month-year").value = monthYearText;
  });
};

const render_dollar_rates_table = () => {
  $("#currency-rates-table").DataTable().destroy();
  $("#currency-rates-table").DataTable({
    fixedHeader: true,
    pageLength: 10,
    processing: true,
    serverSide: true,
    ajax: {
      type: "get",
      url: "/currency_rates",
      dataType: "json",
      data: (data) => {
        data.page =
          parseInt($("#currency-rates-table").DataTable().page.info().page) + 1;
        data.per_page = $("#currency-rates-table")
          .DataTable()
          .page.info().length;
        data.order = $("#currency-rates-table").DataTable().order()[0][0];
        data.direction = $("#currency-rates-table").DataTable().order()[0][1];
        data.search = data.search.value;
        data.currency_rate_month = $("#currency-rates-month")
          .find("option:selected")
          .text();
        data.from = $("#currency-from").find("option:selected").text();
        data.to = $("#currency-to").find("option:selected").text();
      },
    },
  });
};

$(document).on(
  "change",
  "#currency-rates-month, #currency-from, #currency-to",
  () => {
    render_dollar_rates_table();
    $.ajax({
      type: "get",
      dataType: "script",
      url: "/currency_rates",
      data: {
        currency_rate_month: $("#currency-rates-month")
          .find("option:selected")
          .text(),
        show_average_rate: true,
        from: $("#currency-from").find("option:selected").text(),
        to: $("#currency-to").find("option:selected").text(),
      },
    });
  }
);

const filterCurrencyToDropdown = () => {
  const selectedFrom = $("#currency-from").val();
  const $toSelect = $("#currency-to");

  if (!$toSelect.data("original-options")) {
    $toSelect.data(
      "original-options",
      $toSelect
        .find("option")
        .map(function () {
          return {
            value: $(this).val(),
            text: $(this).text(),
          };
        })
        .get()
    );
  }

  const originalOptions = $toSelect.data("original-options");

  $toSelect.empty();
  originalOptions?.forEach((opt) => {
    if (opt.value !== selectedFrom) {
      $toSelect.append($("<option></option>").val(opt.value).text(opt.text));
    }
  });

  $toSelect.trigger("change");
};

$(document).on("change", "#currency-from", function () {
  filterCurrencyToDropdown();
});

$(document).on('change', '#currency_rates_csv', function() {
  var fileName = $(this).val().split('\\').pop();
  var nextSibling = $(this).next('.custom-file-label');

  if (nextSibling.length) { nextSibling.text(fileName); }
});
